import { render, staticRenderFns } from "./ProviderForm.vue?vue&type=template&id=526c674a&scoped=true"
import script from "./ProviderForm.vue?vue&type=script&lang=js"
export * from "./ProviderForm.vue?vue&type=script&lang=js"
import style0 from "./ProviderForm.vue?vue&type=style&index=0&id=526c674a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c674a",
  null
  
)

export default component.exports